import { v4 as uuidv4 } from "uuid";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import { setError } from "./errorSlice";

const initialState = {
  formData: {
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    school: "",
    batch: "",
    termId: "",
    academicYear: "",
    eventTypeID: "",
    eventType: "",
    notes: "",
  },
  filters: {
    schoolId: "All",
    batchId: "All",
    termId: "",
    academicYear: "",
    eventType: "All",
  },
  errors: {},
  events: [],
  allEvents: [],
  selectedEvent: [],
  selectedEvents: [],

  allEventTypes: [],
  selectedEventTypes: [],
  showModal: false,
  isEditing: false,
  editingEventId: null,
  calendarDate: new Date().toISOString(),
  currentPage: 1,
  viewMode: "calendar",
  notification: null,
  // add other properties from your original initialState if any
};
export const fetchAcademicEventTypes = createAsyncThunk(
  "academicCalendar/fetchAcademicEventTypes",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/event-types`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAcademicEventTypesById = createAsyncThunk(
  "academicCalendar/fetchAcademicEventTypesById",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/event-types/{id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const createAcademicEventTypes = createAsyncThunk(
  "academicCalendar/createAcademicEventTypes",
  async ({ eventName, eventDescription }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const payload = {
        eventName,
        eventDescription,
      };
      console.log("JSON.stringify(payload)", JSON.stringify(payload));
      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/event-types`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      return response;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const editAcademicEventTypes = createAsyncThunk(
  "academicCalendar/editAcademicEventTypes",
  async ({ eventTypeId, eventTypeData }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      console.log("eventTYpeId", eventTypeId);
      console.log("eventType", eventTypeData);
      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/event-types/${eventTypeId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(eventTypeData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }
      return response;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const deleteAcademicEventTypes = createAsyncThunk(
  "academicCalendar/deleteAcademicEventTypes",
  async (eventTypeId, { rejectWithValue, dispatch }) => {
    try {
      console.log("eventTypeId", eventTypeId);

      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/event-types/${eventTypeId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      return response;
    } catch (error) {
      console.error("Error in deleting event type:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAcademicCalendarEvents = createAsyncThunk(
  "academicCalendar/fetchAcademicCalendarEvents",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAcademicCalendarEventsByTermId = createAsyncThunk(
  "academicCalendar/fetchAcademicCalendarEventsByTermId",
  async (termId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events/${termId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAcademicCalendarEventsByAccYear = createAsyncThunk(
  "academicCalendar/fetchAcademicCalendarEventsByAccYear",
  async (accYear, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events/${accYear}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAcademicCalendarEventsId = createAsyncThunk(
  "academicCalendar/fetchAcademicCalendarEventsId",
  async (eventId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events/${eventId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const createAcademicCalendarEvents = createAsyncThunk(
  "academicCalendar/createAcademicCalendarEvents",
  async (event, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      console.log("event", event);
      const payload = {
        eventTypeID: event.eventTypeId,
        termID: event.termId || null,
        academicYear: event.academicYear || null,
        schoolID: event?.schoolId === "All" ? null : event?.schoolId || null,
        batchID: event?.batchId === "All" ? null : event?.batchId || null,
        eventStartDate: new Date(`${event.startDate}T00:00:00Z`).toISOString(),
        eventEndDate: new Date(`${event.endDate}T23:59:59Z`).toISOString(),
      };
       console.log("payload", JSON.stringify(payload));
      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      console.log("response", response);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const editAcademicCalendarEvents = createAsyncThunk(
  "academicCalendar/editAcademicCalendarEvents",
  async ({ eventId, event }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const payload = {
        eventTypeID: event.eventTypeId,
        termID: event.termId || null,
        academicYear: event.academicYear || null,
        schoolID: event?.schoolId || null,
        batchID: event?.batchId || null,
        eventStartDate: new Date(`${event.startDate}T00:00:00Z`).toISOString(),
        eventEndDate: new Date(`${event.endDate}T23:59:59Z`).toISOString(),
      };
      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events/${eventId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const deleteAcademicCalendarEvents = createAsyncThunk(
  "academicCalendar/deleteAcademicCalendarEvents",
  async (eventId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/academic-calander/events/${eventId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch applications: ${response.status} ${errorText.slice(
            0,
            100
          )}`
        );
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error in fetchApplications:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

const calendarFormSlice = createSlice({
  name: "calendarForm",
  initialState,
  reducers: {
    setFormData(state, action) {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
      if (action.payload.title) {
        state.errors.title = "";
      }
    },
    setFilters(state, action) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      state.currentPage = 1;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setEvents(state, action) {
      state.events = [...action.payload];
    },
    toggleModal(state, action) {
      state.showModal = action.payload;
      if (!action.payload) {
        state.formData = initialState.formData;
        state.isEditing = false;
        state.editingEventId = null;
      }
      state.errors = {};
    },
    setCalendarDate(state, action) {
      const dateValue = action.payload instanceof Date 
        ? action.payload.toISOString() 
        : action.payload;
      state.calendarDate = dateValue;
    },
    setPage(state, action) {
      state.currentPage = action.payload;
    },
    setViewMode(state, action) {
      state.viewMode = action.payload;
    },
    setEditing(state, action) {
      state.isEditing = action.payload.isEditing;
      state.editingEventId = action.payload.eventId;
    },
    setNotification(state, action) {
      state.notification = action.payload;
    },
    clearNotification(state) {
      state.notification = null;
    },
    resetForm(state) {
      state.formData = initialState.formData;
      state.errors = {};
      state.isEditing = false;
      state.editingEventId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAcademicCalendarEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAcademicCalendarEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.allEvents = action.payload;
        console.log("state.allEvents", state.allEvents);
        state.error = null;
      })
      .addCase(fetchAcademicCalendarEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAcademicCalendarEventsByTermId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAcademicCalendarEventsByTermId.fulfilled,
        (state, action) => {
          state.loading = false;
          state.selectedEvents = action.payload;
          console.log("state.selectedEvents", state.selectedEvents);
          state.error = null;
        }
      )
      .addCase(
        fetchAcademicCalendarEventsByTermId.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      )
      .addCase(fetchAcademicCalendarEventsByAccYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAcademicCalendarEventsByAccYear.fulfilled,
        (state, action) => {
          state.loading = false;
          state.selectedEvents = action.payload;
          console.log(
            "fetchAcademicCalendarEventsByAccYear: state.selectedEvents",
            state.selectedEvents
          );
          state.error = null;
        }
      )
      .addCase(
        fetchAcademicCalendarEventsByAccYear.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      )
      .addCase(fetchAcademicCalendarEventsId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAcademicCalendarEventsId.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedEvent = action.payload;
        console.log("state.selectedEvent", state.selectedEvent);
        state.error = null;
      })
      .addCase(fetchAcademicCalendarEventsId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createAcademicCalendarEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAcademicCalendarEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.allEvents = action.payload;
        console.log("state.allEvents", state.allEvents);
        state.error = null;
      })
      .addCase(createAcademicCalendarEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editAcademicCalendarEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editAcademicCalendarEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.allEvents = action.payload;
        console.log("state.allEvents", state.allEvents);
        state.error = null;
      })
      .addCase(editAcademicCalendarEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAcademicCalendarEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAcademicCalendarEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.allEvents = action.payload;
        console.log("state.allEvents", state.allEvents);
        state.error = null;
      })
      .addCase(deleteAcademicCalendarEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAcademicEventTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAcademicEventTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.allEventTypes = action.payload;
        console.log("state.allEventTypes", state.allEventTypes);
        state.error = null;
      })
      .addCase(fetchAcademicEventTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAcademicEventTypesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAcademicEventTypesById.fulfilled, (state, action) => {
        state.selectedEventTypes = action.payload;
        console.log("state.selectedEventTypes", state.selectedEventTypes);
      })
      .addCase(fetchAcademicEventTypesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createAcademicEventTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAcademicEventTypes.fulfilled, (state, action) => {
        state.loading = false;
        //          state.allEventTypes = action.payload;
        //         console.log("state.allEventTypes", state.allEventTypes);
        state.error = null;
      })
      .addCase(createAcademicEventTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editAcademicEventTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editAcademicEventTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.allEventTypes = action.payload;
        console.log("state.allEventTypes", state.allEventTypes);
        state.error = null;
      })
      .addCase(editAcademicEventTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAcademicEventTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAcademicEventTypes.fulfilled, (state, action) => {
        state.loading = false;
        //          state.allEventTypes = action.payload;
        //          console.log("state.allEventTypes", state.allEventTypes);
        state.error = null;
      })
      .addCase(deleteAcademicEventTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const {
  setFormData,
  setFilters,
  setErrors,
  setEvents,
  toggleModal,
  setCalendarDate,
  setPage,
  setViewMode,
  setEditing,
  setNotification,
  clearNotification,
  resetForm,
} = calendarFormSlice.actions;

export default calendarFormSlice.reducer;
